/*global eclipseApp, $, _, angular*/
(function () {

  'use strict';

  eclipseApp

    .controller('provinceSelectorCtrl', ['$scope', '$element', '$cookies', 'uteModal', 'cartManager', 'provinceMeta', 'provinceService', '$filter', 'uteLocale', function ($scope, $element, $cookies, uteModal, cartManager, provinceMeta, provinceService, $filter, uteLocale) {

      // prevent action from the anchors in the dom
      $($element).on("click", function (e) {
        e.preventDefault();
      });

      // get list of provinces
      $scope.provinces = _.keys(provinceMeta);

      $scope.selectedProvince = uteLocale.province;

      // update province method
      $scope.saveProvince = function (province) {

        // if province of choice is the same as current province, don't proceed with the change
        if (province === uteLocale.province) {
          return false;
        }

        // check if province is being called from the directive or outside
        if (angular.isUndefined(province)) {
          province = $scope.selectedProvince;
        }

        // first check if the shopping cart is empty; prompt user if it isn't
        //$filter('translate')('key')
        if (cartManager.getQuantity() > 0) {
          uteModal.open({
            title: $filter('translate')('global.label.changeProvinceWarning'),
            message: $filter('translate')('global.message.changeProvinceWarning'),
            okButtonLabel: $filter('translate')('global.cta.continue'),
            cancelButtonLabel: $filter('translate')('global.cta.cancel'),
            ok: function () {
              provinceService.checkFootPrint(province).then(function (province) {
                provinceService.update(province);
              }, function (province) {
                $scope.selectedProvince = province;
              });
            },
            cancel: function () {
              $scope.selectedProvince = uteLocale.province;
            }
          });
          return;
        }

        // if the cart is empty
        provinceService.checkFootPrint(province).then(function (province) {
          provinceService.update(province);
        }, function (province) {
          $scope.selectedProvince = province;
        });

      };

    }]);

})();
